import { render, staticRenderFns } from "./CreateTest.vue?vue&type=template&id=57d76292&"
import script from "./CreateTest.vue?vue&type=script&lang=ts&"
export * from "./CreateTest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports